/** The brand the app is acting on. Stored per browser; the api validates it on every request. */
const KEY = 'studio.activeBrand';

export function getActiveBrand(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setActiveBrand(slug: string): void {
  try {
    localStorage.setItem(KEY, slug);
  } catch {
    /* private mode: the api falls back to the first brand */
  }
}

/**
 * A stored brand can outlive its slug (renamed) or the person's membership (removed), and the api
 * refuses every request naming it. Forgets it and asks once more; the api then picks the first brand.
 */
export async function withoutStaleBrand<T>(request: () => Promise<T>, isStale: (err: unknown) => boolean): Promise<T> {
  try {
    return await request();
  } catch (err) {
    if (!isStale(err) || getActiveBrand() === null) throw err;
    try {
      localStorage.removeItem(KEY);
    } catch {
      throw err;
    }
    return request();
  }
}

/** Switching reloads the app so every query, queue and channel belongs to the new brand. */
export function switchBrand(slug: string): void {
  setActiveBrand(slug);
  location.assign('/');
}
